import { findWithRegex } from './findWithRegex';
export var entityRegexStrategy = function entityRegexStrategy(entity, regex) {
  return function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === entity;
    }, function (start, end) {
      return callback(start, end);
    });
    findWithRegex(regex, contentBlock, callback);
  };
};